module.exports = __webpack_public_path__ + "img/cptx2@2x.cf246263.png";